module.exports = __webpack_public_path__ + "static/media/A7.76413056.mp3";